import Immutable from "seamless-immutable";
import * as actionTypes from "./actionTypes";

const initialState = Immutable({
  byId: {},
  data: {},
  params: {},
  actionsloading: false,
});

export function emailLogsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_EMAILSTATISTICS:
      return {
        ...state,
        actionsloading: true,
      };
    case actionTypes.GET_EMAILSTATISTICS_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        data: action.payload.data,
        actionsloading: false,
      };
    default:
      return state;
  }
}
